import { ACTIONS } from "app/store/actions"
import { Action } from "redux"
import { IReportForm, IReportParameters, IReportResult, IReportTotal, IUserReport } from "reports/model"
import { IChartDataSet } from "ui/configuration/model"

export interface IActionReportsSetParameters extends Action {
  isCreation: boolean
  parameters: IReportParameters
  updateFormError: string
  isResultLoading: boolean
}

export interface IActionReportsSetResults extends Action {
  isCreation: boolean
  results: IReportResult[]
  parameters: IReportParameters
}

export interface IActionReportsSetIsLoading extends Action {
  isCreation: boolean
  isLoading: boolean
}

export interface IActionReportsUserReport extends Action {
  userReport: IUserReport
}

export interface IActionReportsDelete extends Action {
  userReportId: number
}

export interface IActionReportsSetIsParametersPanelOpened extends Action {
  isCreation: boolean
  isParametersPanelOpened: boolean
}

export interface IActionReportsSetHasLoadingError extends Action {
  isCreation: boolean
  hasLoadingError: boolean
}

export interface IActionReportsSetList extends Action {
  userReports: IUserReport[]
}

export interface IActionReportsSetEditForm extends Action {
  form: IReportForm
}

export interface IActionReportsSetFormIsUpdating extends Action {
  isUpdating: boolean
}

export interface IActionSetRevenue extends Action {
  chartDataSets: IChartDataSet[]
  total: IReportTotal | null
}

export const reportsActionCreator = {
  setFormIsUpdating(isUpdating: boolean): IActionReportsSetFormIsUpdating {
    return {
      type: ACTIONS.REPORTS_SET_FORM_IS_UPDATING,
      isUpdating
    }
  },
  setEditForm(form: IReportForm): IActionReportsSetEditForm {
    return {
      type: ACTIONS.REPORTS_SET_EDIT_FORM,
      form
    }
  },
  setParameters(
    isCreation: boolean,
    parameters: IReportParameters,
    updateFormError: string,
    isResultLoading: boolean
  ): IActionReportsSetParameters {
    return {
      type: ACTIONS.REPORTS_SET_PARAMETERS,
      isCreation,
      parameters,
      updateFormError,
      isResultLoading
    }
  },
  setResults(isCreation: boolean, results: IReportResult[], parameters: IReportParameters): IActionReportsSetResults {
    return {
      type: ACTIONS.REPORTS_SET_RESULTS,
      isCreation,
      results,
      parameters
    }
  },
  setIsParametersPanelOpened(
    isCreation: boolean,
    isParametersPanelOpened: boolean
  ): IActionReportsSetIsParametersPanelOpened {
    return {
      type: ACTIONS.REPORTS_SET_IS_PARAMETERS_PANEL_OPENED,
      isCreation,
      isParametersPanelOpened
    }
  },
  setIsResultLoading(isCreation: boolean, isLoading: boolean): IActionReportsSetIsLoading {
    return {
      type: ACTIONS.REPORTS_SET_RESULT_IS_LOADING,
      isCreation,
      isLoading
    }
  },
  setHasLoadingError(isCreation: boolean, hasLoadingError: boolean): IActionReportsSetHasLoadingError {
    return {
      type: ACTIONS.REPORTS_SET_RESULT_HAS_LOADING_ERROR,
      isCreation,
      hasLoadingError
    }
  },
  setIsListLoading(isLoading: boolean): IActionReportsSetIsLoading {
    return {
      type: ACTIONS.REPORTS_SET_LIST_IS_LOADING,
      isCreation: false, // isCreation will not be used by reducer here
      isLoading
    }
  },
  setListHasLoadingError(hasLoadingError: boolean): IActionReportsSetHasLoadingError {
    return {
      type: ACTIONS.REPORTS_SET_LIST_HAS_LOADING_ERROR,
      isCreation: false, // isCreation will not be used by reducer here
      hasLoadingError
    }
  },
  addUserReport(userReport: IUserReport): IActionReportsUserReport {
    return {
      type: ACTIONS.REPORTS_ADD,
      userReport
    }
  },
  updateUserReport(userReport: IUserReport): IActionReportsUserReport {
    return {
      type: ACTIONS.REPORTS_UPDATE,
      userReport
    }
  },
  deletUserReport(userReportId: number): IActionReportsDelete {
    return {
      type: ACTIONS.REPORTS_DELETE,
      userReportId
    }
  },
  setReportsList(userReports: IUserReport[]): IActionReportsSetList {
    return {
      type: ACTIONS.REPORTS_SET_LIST,
      userReports
    }
  },
  startLoadingRevenu(): Action {
    return {
      type: ACTIONS.REVENUE_START_LOADING
    }
  },
  setRevenu(chartDataSets: IChartDataSet[], total: IReportTotal | null): IActionSetRevenue {
    return {
      type: ACTIONS.REVENUE_SET,
      chartDataSets,
      total
    }
  },
  setRevenuError(): Action {
    return {
      type: ACTIONS.REVENUE_SET_ERROR
    }
  }
}
